import { createStore } from "vuex";
import {auth} from "./auth.js";

const store = createStore({
    strict: true,
    modules : {
        auth
    }
});

export default store
